import axios from 'axios';

const apiWSCOM = axios.create({
  baseURL: 'https://wscom.apolar.net/',
  auth: {
    username: 'apolar',
    password: '123',
  },
});

export default apiWSCOM;
